"use client";
import Image from "next/image";
import { useState } from 'react';
import { avenirNextRegular, avenirNextMedium } from '@/styles/fonts'
import clsx from 'clsx';
import Link from "next/link";

// Logo imports
import aol1Logo from '@/app/images/logos/aol1.png';
import salesdeskLogo from '@/app/images/logos/salesdesk.png';
import creditkarmaLogo from '@/app/images/logos/creditkarma1.png';
import equifaxLogo from '@/app/images/logos/equifax1.png';
import amazonLogo from '@/app/images/logos/amazon1.png';
import dellLogo from '@/app/images/logos/dell.png';
import ancestryLogo from '@/app/images/logos/ancestry.png';
import changeLogo from '@/app/images/logos/change.png';
import designsLogo from '@/app/images/logos/99designs.png';
import buzzfeedLogo from '@/app/images/logos/buzzfeed.png';
import mcgarrybowenLogo from '@/app/images/logos/mcgarrybowen.png';
import marshallfennLogo from '@/app/images/logos/marshallfenn.png';
import mindshareLogo from '@/app/images/logos/mindshare.png';
import mundomediaLogo from '@/app/images/logos/mundomedia.png';
import yahooLogo from '@/app/images/logos/yahoo1.png';
import acqLogo from '@/app/images/logos/acq.png';
import redLogo from '@/app/images/logos/50red.png';
import acuityLogo from '@/app/images/logos/acuity.png';


function HomeAAN() {
  const [tab, setTab] = useState(0);


  const classMain = ["flex place-content-center",
    "flex-col md:flex-row",
    "items-start",
    "gap-y-3",
    "mt-[15px] sm:mt-[35px] md:mt-[60px] lg:mt-[85px]"];
  const classLeftDiv = [
    "rounded-[6px] border-[5px] shadow-md",
    "w-[93%] sm:w-[72%] md:w-[50%] lg:w-[455px] xl:w-[500px]",
    "mx-auto md:mx-[15px] lg:mx-[15px]",
    "mb-[10px] lg:mb-0"

  ];
  const classLeftDiv0 = "bg-[#0f8dbc] border-[#0f8dbc]";
  const classLeftDiv1 = "bg-[#4cac9a] border-[#4cac9a]";
  const classLeftDiv2 = "bg-[#eea753] border-[#eea753]";
  const classLeftDivImg = [
    "w-full"
  ];

  const classLeftDivDiv = ["text-justify",
    "px-[25px] sm:px-[38px]",
    "pb-[20px] sm:pb-[65px]",
    "pt-[20px] sm:pt-[42px]"

  ];
  const classLeftDivDivImg = ["mb-[20px]"];
  const classLeftDivDivP = [avenirNextRegular.className,
    "text-white ",
    "text-[13px] sm:text-[17px] lg:text-[17px] ",
    "leading-[22px] sm:leading-[30px] lg:leading-[30px]"
  ];
  const classRightDiv = ["text-justify",
    "w-full md:w-[50%] lg:w-[455px] xl:w-[500px]",
    "px-[15px]",
    "lg:mx-[15px]"

  ];
  const classRightDivH2 = [avenirNextMedium.className,
    "text-[#43484c]",
    "text-left",
    "text-[18px] sm:text-[26px] md:text-[28px] lg:text-[32px]",
    "leading-[27px] sm:leading-[36px] lg:leading-[45px]"
  ];

  const classRightHr = ["my-[10px] sm:my-[20px]"];
  const classRightP = [avenirNextRegular.className,
    "text-[#5e6977]",
    "text-left",
    "text-[14px] sm:text-[18px] lg:text-[22px]",
    "leading-[22px] sm:leading-[30px] lg:leading-[35px]"
  ];

  const classRightA = [avenirNextMedium.className, "hover:underline",
    "text-[14px] sm:text-[18px] text-left"
  ];
  const classRightA0 = "text-[#0086b9]";
  const classRightA1 = "text-[#4cac9a]";
  const classRightA2 = "text-[#eea753]";

  const classLogos = [
    "flex flex-wrap justify-center items-center mx-auto",
    "mt-[10px] sm:mt-[30px] lg:mt-[90px]",
    "w-full",
    "px-[30px]",
    "gap-x-3 gap-y-1",
  ];
  const classLogoImage = [
    "!h-auto",
    "w-[calc(50%-1.25rem)]",
    "max-w-[170px]",
    "sm:w-auto"
  ];

  return (
    <section className={clsx(
      "bg-[#f9f9f9] w-full",
      "pt-[16px] sm:pt-[35px] lg:pt-[90px]",
      "pb-[25px] sm:pb-[45px] lg:pb-[60px]"
    )}>
      <div className={clsx(
        "w-full md:w-[750px] lg:w-[970px] xl:w-[1170px] mx-auto",
      )} >
        <h1 className={clsx(avenirNextMedium.className, "text-[#43484c]",
          "mb-[11px] sm:mb-[20px] md:mb-[25px]",
          "text-[21px] sm:text-[35px] md:text-[45px] lg:text-[48px]")}>
          Adbeat is built with you in mind
        </h1>

        <div className={clsx(avenirNextMedium.className,
          "flex items-center place-content-center mx-auto",
          "flex-col sm:flex-row",
          "mb-[5px]",
          "w-full sm:w-[550px]",
          "")}>
          {["Advertisers", "Agencies", "Ad Networks & Publishers"].map(
            (value: string, index: number) => (
              <button key={index} onClick={() => setTab(index)} className={clsx(
                'shadow-md rounded-[4px] border bg-white',
                'hover:text-[#0086b9] focus:outline-none',
                "block md:inline-block",
                "w-[85%] sm:w-auto",
                "mx-[5px] md:mx-[8px]",
                "mb-[5px] sm:mb-[0px]",
                "px-[18px] sm:px-[25px]",
                "py-[6px] sm:py-[8px]",
                "text-[14px] sm:text-[16px]",
                tab == index && 'border-[#0086b9] text-[#0086b9]',
                tab != index && 'border-white text-[#5e6977]'
              )}>{value}</button>
            )
          )}
        </div>


        <div className={clsx(tab != 0 && 'hidden', ...classMain)}>
          <div className={clsx(...classLeftDiv, classLeftDiv0)}>
            <Image src="/public/images/box2.webp" className={clsx(...classLeftDivImg)}
              width={488} height={382} alt="The image features a Mac desktop with a cup of pens, a glass flower pot, and a wooden alligator toy." />
            <div className={clsx(...classLeftDivDiv)}>
              <Image src="/public/images/box.png" width={55} height={30} alt="Box company logo." className={clsx(...classLeftDivDivImg)} />
              <p className={clsx(...classLeftDivDivP)}>
                A leader in secure file sharing, Box uses Adbeat to keep tabs on how competitors in their industry are using digital channels to get their message out. Adbeat helps Box to make smarter decisions about their own messaging and strategy.</p>
            </div>
          </div>
          <div className={clsx(...classRightDiv)}>
            <h2 className={clsx(...classRightDivH2)}>
              Adbeat provides unparalleled insights into the complex world of digital advertising.
              It makes perfect sense that leading companies like Box, Ancestry, and Lending Tree use Adbeat.
            </h2>
            <hr className={clsx(...classRightHr)} />
            <p className={clsx(...classRightP)}>With Adbeat, advertisers can see what direct competitors are doing and how they&apos;re doing it. Besides just seeing ads and the messaging being used, we&apos;re also able to show you the sources of traffic including how the media was purchased and what publishers the ads were running on. <br /><br /> As your business grows, Adbeat helps you spend your advertising dollars smarter.</p>
            <hr className={clsx(...classRightHr)} />
            <Link className={clsx(...classRightA, classRightA0)} href="/advertisers">See how other advertisers use Adbeat ❯</Link>
          </div>
        </div>
        <div className={clsx(tab != 0 && 'hidden', ...classLogos)}>

          <Image src={aol1Logo} alt="aol" width={80} height={88} />
          <Image src={salesdeskLogo} alt="salesdesk" width={207} height={88} className={clsx(...classLogoImage)} />
          <Image src={creditkarmaLogo} alt="creditkarma" width={191} height={88} className={clsx(...classLogoImage)} />
          <Image src={equifaxLogo} alt="equifax" width={160} height={88} className={clsx(...classLogoImage)} />
          <Image src={amazonLogo} alt="amazon" width={161} height={88} className={clsx(...classLogoImage)} />
          <Image src={dellLogo} alt="dell" width={69} height={88} />
          <Image src={ancestryLogo} alt="ancestry" width={226} height={88} className={clsx(...classLogoImage)} />
          <Image src={changeLogo} alt="change" width={204} height={88} className={clsx(...classLogoImage)} />
          <Image src={designsLogo} alt="99designs" width={169} height={88} className={clsx(...classLogoImage)} />
          <Image src={buzzfeedLogo} alt="buzzfeed" width={180} height={88} className={clsx(...classLogoImage)} />
        </div>

        <div className={clsx(tab != 1 && 'hidden', ...classMain)}>
          <div className={clsx(...classLeftDiv, classLeftDiv1)}>
            <Image src="/public/images/agencies.png" className={clsx(...classLeftDivImg)}
              width={523} height={399} alt="The image features a Mac desktop with a cup of pens, a glass flower pot, and a wooden alligator toy." />
            <div className={clsx(...classLeftDivDiv)}>
              <Image src="/public/images/imm.png" width={61} height={23} alt="IMM logo." className={clsx(...classLeftDivDivImg)} />
              <p className={clsx(...classLeftDivDivP)}>
                To help deliver on their core promise of being results and performance focused, full service digital agency IMM uses Adbeat to exceed their client&apos;s expectations by delivering near real-time insights into how and where their competitors are advertising online.
              </p>
            </div>
          </div>
          <div className={clsx(...classRightDiv)}>
            <h2 className={clsx(...classRightDivH2)}>
              Successful agencies use Adbeat to exceed client expectations and turn themselves into a more valuable partner.
            </h2>
            <hr className={clsx(...classRightHr)} />
            <p className={clsx(...classRightP)}>
              With Adbeat, advertisers can see what direct competitors are doing and how they&apos;re doing it. Besides just seeing ads and the messaging being used, we&apos;re also able to show you the sources of traffic including how the media was purchased and what publishers the ads were running on.
              <br /><br />
              As your business grows, Adbeat helps you spend your advertising dollars smarter.</p>
            <hr className={clsx(...classRightHr)} />
            <Link className={clsx(...classRightA, classRightA1)} href="/agencies">See how other agencies use Adbeat ❯</Link>
          </div>
        </div>
        <div className={clsx(tab != 1 && 'hidden', ...classLogos)}>
          <Image src={mcgarrybowenLogo} alt="mcgarrybowen" width={262} height={88} className={clsx(...classLogoImage)} />
          <Image src={marshallfennLogo} alt="marshallfenn" width={201} height={88} className={clsx(...classLogoImage)} />
          <Image src={mindshareLogo} alt="mindshare" width={281} height={88} className={clsx(...classLogoImage)} />
          <Image src={mundomediaLogo} alt="mundomedia" width={263} height={88} className={clsx(...classLogoImage)} />
        </div>


        <div className={clsx(tab != 2 && 'hidden', ...classMain)}>
          <div className={clsx(...classLeftDiv, classLeftDiv2)}>
            <Image src="/public/images/networks.png" className={clsx(...classLeftDivImg)}
              width={523} height={450} alt="ad networks image" />
            <div className={clsx(...classLeftDivDiv)}>
              <Image src="/public/images/cpxi.png" width={86} height={33} alt="CPXi logo." className={clsx(...classLeftDivDivImg)} />
              <p className={clsx(...classLeftDivDivP)}>
                Ad network CPXi specializes in selling media to performance marketers.  As they continue to expand, they use Adbeat to prospect for new advertisers and publishers.  These new prospects help them sell more inventory and drive revenue.
              </p>
            </div>
          </div>
          <div className={clsx(...classRightDiv)}>
            <h2 className={clsx(...classRightDivH2)}>
              Adbeat is built with publishers and ad networks in mind.  For any given publisher, you&apos;ll see the ad networks they&apos;re using to sell inventory and advertisers that are buying it.
            </h2>
            <hr className={clsx(...classRightHr)} />
            <p className={clsx(...classRightP)}>
              With Adbeat you&apos;re able to spot trends that are impossible to see any other way.  Easily see when advertiser are increasing their spends on other networks and publishers.  If you&apos;re an ad network, you&apos;ll appreciate how Adbeat can show you when competing networks add new strong publishers to their offerings.
              <br /><br />
              Adbeat lets you prospect for new revenue, smarter and more efficiently.
            </p>
            <hr className={clsx(...classRightHr)} />
            <Link className={clsx(...classRightA, classRightA2)} href="/adnetworks_publishers">See how other networks &amp; publishers use Adbeat ❯</Link>
          </div>
        </div>
        <div className={clsx(tab != 2 && 'hidden', ...classLogos)}>
          <Image src={yahooLogo} alt="yahoo" width={237} height={88} className={clsx(...classLogoImage)} />
          <Image src={acqLogo} alt="acq" width={257} height={88} className={clsx(...classLogoImage)} />
          <Image src={redLogo} alt="mindshare" width={177} height={88} className={clsx(...classLogoImage)} />
          <Image src={acuityLogo} alt="acuity" width={178} height={88} className={clsx(...classLogoImage)} />
        </div>
      </div>
    </section>
  );
}

export default HomeAAN;
